import CrudCustom from '../../../libs/custom/CrudCustom';

let KategoriPph25Service = new CrudCustom('/kategori-p-ph-25-s');
export default KategoriPph25Service;
